import classNames from 'classnames';
import { FC } from 'react';

import styles from './CheckBoxInput.module.scss';

interface CheckBoxInputProps {
  className?: string;
  disabled?: boolean;
  id: string;
  isChecked: boolean;
  label: string;
  onCheck: (isChecked: boolean) => void;
  smallLabel?: boolean;
}

const CheckBoxInput: FC<CheckBoxInputProps> = ({ id, label, isChecked, disabled, smallLabel, onCheck, className = '' }) => {
  const labelStyle = classNames({
    [styles.smallLabel]: !!smallLabel,
    [styles.disabled]: disabled,
  });

  const wrapperStyle = classNames({
    [styles.inputField]: true,
    [className]: !!className
  });

  return (
    <div className={wrapperStyle} key={label}>
      <input
        checked={isChecked}
        disabled={disabled}
        id={id}
        name={id}
        onChange={(event): void => onCheck(event.target.checked)}
        type="checkbox"
      />
      <label className={labelStyle} htmlFor={id}>{label}</label>
    </div>
  );
};

export default CheckBoxInput;
